import {
  Content,
  Group,
  Item,
  ItemIndicator,
  ItemText,
  Label,
  Portal,
  Root,
  Separator,
  Trigger,
  Value,
} from './Select';

export const Select = {
  Content,
  Item,
  Portal,
  Root,
  Trigger,
  Value,
  Group,
  Label,
  Separator,
  ItemText,
  ItemIndicator,
};
